import styled from 'styled-components';
import { LinkButton } from 'components/ui/Button';
import { ButtonContent } from 'components/ui/Button/Button.styles';

import { colours } from 'themes/default';

export const StyledLinkButton = styled(LinkButton)`
  color: ${colours.Shades.BlueShade40};

  ${ButtonContent} {
    > :first-child {
      margin-right: 5px;
      width: 20px;
      height: 20px;
    }
  }
`;

export const StyledH1 = styled.h1`
  margin-top: 25px;
  margin-bottom: 50px;
`;

export const StyledH2 = styled.h2`
  margin-top: 40px;
  margin-bottom: 25px;
`;

export const StyledH3 = styled.h3`
  margin-top: 30px;
  margin-bottom: 25px;
`;

export const StyledDiv = styled.div`
  margin-left: 30px;
`;
